import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — resets scroll position on every route change so each dedicated
 * page opens at the top (expected multi-page behaviour). Hash links are left
 * alone so in-page anchors still work.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, hash]);
    return null;
}
